import React__default, { Component } from 'react';
import cx from 'classnames';
import { f as isEmpty } from './helpers-1066b771.js';

var styles = {"mw-label-container":"LabelContainer_mw-label-container__3k8R7","mw-label-wrapper":"LabelContainer_mw-label-wrapper__1pVu8","mw-label-optional":"LabelContainer_mw-label-optional__3aYuT","mw-label-box":"LabelContainer_mw-label-box__YCBWl","mw-label-padding-box":"LabelContainer_mw-label-padding-box__efQQX"};

class LabelContainer extends Component {
  render() {
    const {
      label,
      className,
      labelBeforeClassName,
      labelBefore,
      labelAfterClassName,
      labelAfter,
      optionalLabel,
      labelContainer
    } = this.props;

    // ========= Chunked Components ===========================
    const Label = ({
      className
    }) => {
      return /*#__PURE__*/React__default.createElement("span", {
        className: cx(styles['mw-label-wrapper'], className)
      }, label);
    };
    const Optional = ({
      className
    }) => {
      return /*#__PURE__*/React__default.createElement("span", {
        className: cx(styles['mw-label-optional'], styles['mw-label-padding-box'], 'mw-label-optional', className)
      }, "Optional");
    };

    // ========= Helper Fuctions ===========================
    const isLabelContainer = position => {
      return position === labelContainer;
    };
    const renderBeforeLabel = () => {
      const shouldLabelBeHere = isLabelContainer('labelBefore');
      if (isEmpty(labelBefore)) {
        if (shouldLabelBeHere) return /*#__PURE__*/React__default.createElement(Label, null);
        return null;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: cx(styles['mw-label-box'], labelBeforeClassName)
      }, labelBefore, shouldLabelBeHere ? /*#__PURE__*/React__default.createElement(Label, {
        className: styles['mw-label-padding-box']
      }) : null);
    };
    const renderAfterLabel = () => {
      const shouldLabelBeHere = isLabelContainer('labelAfter');
      const renderOptional = optionalLabel ? /*#__PURE__*/React__default.createElement(Optional, null) : null;
      if (isEmpty(labelAfter)) {
        if (shouldLabelBeHere) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: cx(styles['mw-label-box'], labelAfterClassName)
          }, /*#__PURE__*/React__default.createElement(Label, null), renderOptional);
        }
        return renderOptional;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: cx(styles['mw-label-box'], labelAfterClassName)
      }, shouldLabelBeHere ? /*#__PURE__*/React__default.createElement(Label, {
        className: styles['mw-label-padding-box']
      }) : null, renderOptional, labelAfter);
    };
    const renderLabel = () => {
      if (isEmpty(labelContainer)) return /*#__PURE__*/React__default.createElement(Label, null);
      return null;
    };

    // ========= Render ===========================
    return /*#__PURE__*/React__default.createElement("div", {
      className: cx(styles['mw-label-container'], className)
    }, renderBeforeLabel(), renderLabel(), renderAfterLabel());
  }
}

export default LabelContainer;
